import { ScheduleImportModal } from '../../../components/collections/ScheduleImportModal'
import { useScheduleImport } from '../../../hooks'

interface ScheduleImportModalWrapperProps {
  caseId: string
  requestId: string
  onClose: () => void
  onComplete: () => void
}

export function ScheduleImportModalWrapper({
  caseId,
  requestId,
  onClose,
  onComplete,
}: ScheduleImportModalWrapperProps): React.ReactElement {
  const { importing, downloading, result, error, importCsv, downloadCsv, clearResult } =
    useScheduleImport()
  const handleClose = (): void => {
    if (result) onComplete()
    onClose()
  }
  return (
    <ScheduleImportModal
      open
      onClose={handleClose}
      importing={importing}
      downloading={downloading}
      result={result}
      error={error}
      onImport={(file) => {
        void importCsv(caseId, requestId, file)
      }}
      onDownloadTemplate={() => {
        void downloadCsv(caseId, requestId)
      }}
      onClearResult={clearResult}
    />
  )
}
